module.exports = __webpack_public_path__ + "img/bookshelves.4939ee45.svg";